/**
 * Assessments API (Psychometric Tests) — catalog, recommend, questions, submit, results, interpret, vacancy tests.
 */

import { apiFetch } from './core'

export const assessments = {
    catalog: () => apiFetch('/assessments/catalog'),
    recommend: (data) => apiFetch('/assessments/recommend', {
        method: 'POST',
        body: JSON.stringify(data),
    }),
    questions: (code, lang = 'ru') => apiFetch(`/assessments/questions/${code}?lang=${lang}`),
    submit: (data) => apiFetch('/assessments/submit', {
        method: 'POST',
        body: JSON.stringify(data),
    }),
    results: (candidateId, code) => {
        const qs = code ? `?code=${code}` : ''
        return apiFetch(`/assessments/results/${candidateId}${qs}`)
    },
    interpret: (candidateId, data) => apiFetch(`/assessments/interpret/${candidateId}`, {
        method: 'POST',
        body: JSON.stringify(data || {}),
    }),
    setVacancyTests: (vacancyId, testCodes) => apiFetch(`/assessments/vacancy/${vacancyId}/tests`, {
        method: 'PUT',
        body: JSON.stringify({ test_codes: testCodes }),
    }),
    types: () => apiFetch('/assessments/types'),
}
